function toggleModal(modal) {

    if (modal.classList.contains('show')) {
        //is open -> close
        modal.classList.remove('show')
        document.body.classList.remove('modal-open')

    } else {
        //is close -> open
        modal.classList.add('show')
        document.body.classList.add('modal-open')

    }

}

document.querySelectorAll('.custom-modal').forEach(modal => {
    const target = modal.dataset.target;
    const targetClose = modal.dataset.targetclose;

    if (target != null) {
        modal.addEventListener('click', e => {
            toggleModal(document.querySelector(target))
        })
    }

    if (targetClose != null) {
        document.querySelector(targetClose).addEventListener('click', e => {

            toggleModal(document.querySelector(target))
        })
    }

    document.querySelector(target).addEventListener('click', e => {
        if (e.target != document.querySelector(target))
            return;
        document.querySelector(targetClose).click();

    })

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
            if (document.querySelector(target).classList.contains('show')) {
                document.querySelector(targetClose).click();
            }
        }
    };
})
